import { API_ENDPOINTS } from "../../../../Api/apiEndPoints"
import axiosInstance from "../../../../Api/axiosInstance"

export const  getUserManagement = async(params:any)=>{
  let response = await axiosInstance.get(API_ENDPOINTS.SETTING.GET_USER_MANAGEMENT,{params});
  const rowData = response?.data;
  console.log("🚀 ~ getUserManagement ~ rowData:", rowData.data);
  
  const formatedData = Array.isArray(rowData.data.data) ?
  rowData.data.data.map((item:any)=>({
    Name:item.Name ||'-',
    EmployeeId:item.EmployeeId || '-',
    Email:item.Email ||'-',
    UserId:item.UserId || '-',
    Role:item.Roles.RoleName || '-',
    RoleId:item.Roles.RoleId || '-',

    StatusValue:item.StatusValue ||'-',
    LastLogin:item.LastLogin ||'-',
    linked: item.EmployeeId|| '-',
    Phone:item.Phone || '-'

  })) : [];
  
  return{formatedData,rowData};
}


export const updateUser = async(id:number,ReqBody:any)=>{
  const url = `${API_ENDPOINTS.SETTING.PUT_UPDATE_USER}/${id}`;
  let reponse = await  axiosInstance.put(url, ReqBody);

}
 

export const  getUserConfigStatus = async()=>{
  let response = await axiosInstance.get(API_ENDPOINTS.SETTING.GET_USER_CONFIG_STATUS);
  const rowData  = await response?.data;
  const formatedStatus = Object.entries(rowData.data?.userStatus || {}).map(([key,value])=>({
    id:key,
    label:String(value)
  }))
  return{formatedStatus,rowData};
}